export default "__VITE_ASSET__f5d3f195__"